/* Etiquetas multiidoma en castellano. */
export default {
  "bookingListItem.CANCELLED": "Cancelada",
  "bookingListItem.CONFIRMED": "Confirmada",
  "bookingListItem.ON_REQUEST": "Pendiente",
  "bookingListItem.result.empty": "Sin resultados",
};
